import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Title from "src/components/CustomizePayment/CustomerRequestedTaxes/Title";
import "src/components/CustomizePayment/CustomerRequestedTaxes/CustomerRequestedTaxes.scss";
import AddTaxesBooleanToggle from "src/components/CustomizePayment/CustomerRequestedTaxes/AddTaxesBooleanToggle";
import Description from "src/components/CustomizePayment/CustomerRequestedTaxes/Description";
import ZipCode from "src/components/CustomizePayment/ZipCode";
import { patchDealPerson } from "src/store/dataService/actions/deal";
import { getZipCode } from "src/store/selectors/person";
import { ApplicationStore } from "Types/state";

const CustomerRequestedTaxes = ({
    isCountryUS,
    uuid,
    getUserPostalCode,
    patchDealPersonWithZipCode
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const hasUserEnteredZipCode = Boolean(getUserPostalCode);

    const [hasUserAddedTaxes, setUserAddedTaxes] = useState(hasUserEnteredZipCode);

    const handleOnChange = (name: string, value: "yes" | "no") => {
        if (value === "no") {
            (patchDealPersonWithZipCode(uuid, { zip: null }));
            setUserAddedTaxes(false);
            return;
        }
        setUserAddedTaxes(true);
    };

    return (
        <div className={"customer_requested_taxes_container"}>
            <Title />
            <AddTaxesBooleanToggle
                onChange={handleOnChange}
                isDefault={hasUserAddedTaxes}
            />
            {hasUserAddedTaxes && (
                <>
                    <ZipCode
                        placeholder={t(
                            `${
                                isCountryUS
                                    ? `CustomerRequestedTaxes.input.label.zipCode`
                                    : `CustomerRequestedTaxes.input.label.postalCode`
                            }`
                        )}
                    />
                    <Description
                        className={"customer_requested_taxes_description"}
                        description={
                            isCountryUS
                                ? "CustomerRequestedTaxes.description.zipCode"
                                : "CustomerRequestedTaxes.description.postalCode"
                        }
                    />
                </>
            )}
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    isCountryUS: state.account?.address?.country === "US",
    uuid: state.deal.uuid as string,
    getUserPostalCode: getZipCode(state) as string,
});

const mapDispatchToProps = {
    patchDealPersonWithZipCode: patchDealPerson,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerRequestedTaxes);
